import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../controls/Modal';

// Модалка: игра не готова к запуску (список пробелов bundle).
export default function BundleIncompleteModal({ details, onClose }) {
    const items = Array.isArray(details) ? details : [];
    const footer = <button type="button" className="btn btn-primary" onClick={onClose}>OK</button>;

    return (
        <Modal open title="Игра не готова к запуску" onClose={onClose} size="sm" footer={footer}>
            <div className="t-caption">Нужно устранить следующие пробелы и снова нажать «В ожидание»:</div>
            {items.length > 0 ? (
                <ul className="bi-list">
                    {items.map((d, i) => (
                        <li key={i}><b>{d.field || '—'}</b>: {d.message || JSON.stringify(d)}</li>
                    ))}
                </ul>
            ) : (
                <div className="t-caption">Подробности не получены, проверьте раунды/вопросы/команды.</div>
            )}
        </Modal>
    );
}

BundleIncompleteModal.propTypes = {
    details: PropTypes.array,
    onClose: PropTypes.func.isRequired
};

BundleIncompleteModal.defaultProps = { details: [] };
